/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "./RegulationCreate.scss";
import { withTranslation } from "react-i18next";
import { Button, Modal, Form, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import { BiTrash, BiPlus } from "react-icons/bi";
import { RiskReportFrequency } from "../../../../core/constants/common";
import RiskConfigService from "../../../../core/service/RiskConfigService";
import { RISKPARAMCOLORS } from "../../../../core/constants/common";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";
import { RegulationContext } from "../../../../App";
import { BsQuestionCircle } from "react-icons/bs";


const RegulationCreate = ({ t, handleCreateReg, editReg, configType }) => {
  var data = JSON.parse(localStorage.getItem("authority"));
  const [show, setShow] = useState(true);
  const [validated, setValidated] = useState(false);
  const [regulation, setRegulation] = useState(editReg ? editReg.name : "");
  const [frequency, setFrequency] = useState(editReg ? editReg.frequency : "");
  const [isEdit, setIsEdit] = useState(editReg ? true : false);
  const [addRiskParameter, setAddRiskParameter] = useState(false);
  const [editRiskParameterId, setEditRiskParameterId] = useState("");
  const [shown, setShown] = useState(false);
  const [showAddRiskCategory, setShowAddRiskCategory] = useState(false);
  const { glbRegulations, setGlbRegulations } = useContext(RegulationContext);
  const [showParamValidationMsg, setShowParamValidationMsg] = useState(false);

  // const [inputFields, setInputFields] = useState(editReg ? editReg.resultConfigs : [
  //   { resultType: "", colorCode: "", minScore: "", maxScore: "" },
  // ]);
  const [inputFields, setInputFields] = useState([]);

  var isDisabled = data.roles.includes("SUPER_ADMIN") ? "" : "disabled";

  useEffect(() => {
    if (editReg) {
      RiskConfigService.getRegulationDetails(editReg.id)
        .then((response) => {
          response.data.resultConfigs &&
            setInputFields(response.data.resultConfigs);
        })
        .catch((error) => {
          //ErrorHandlingService.handleError(error.response.status);
        });
    }
  }, []);
  const handleClose = () => {
    setShow(false);
    handleCreateReg(false);
  };
  const handleShow = () => setShow(true);

  const options = RiskReportFrequency({ t });

  const handleCreateRegulation = () => {
    inputFields.length === 0 && addNewCategory();
    if (!regulation || !frequency || inputFields.length <= 0) {
      setShow(true);
    } else {
      setShow(false);
      setShowParamValidationMsg(false);
      const params = {
        name: regulation,
        frequency: frequency,
        resultConfigs: inputFields,
      };
      RiskConfigService.createRegulation(params)
        .then((response) => {
          if (response.status === 201) {
            setGlbRegulations(response.data);
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          handleCreateReg(false);
        })
        .catch((error) => {
          // toast.error(error.message, {
          //   position: toast.POSITION.TOP_RIGHT,
          // });
        });
    }
    setValidated(true);
  };
  const handleEditRegulation = () => {
    inputFields.length === 0 && addNewCategory();
    if (!regulation || !frequency || inputFields.length <= 0) {
      setShow(true);
    } else {
      editReg.name = regulation;
      editReg.frequency = frequency;
      editReg.resultConfigs = inputFields;
      RiskConfigService.updateRegulation(editReg, editReg.id)
        .then((response) => {
          if (response.status === 200) {
            setGlbRegulations(response.data);
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
          handleCreateReg(false, editReg.id);
        })
        .catch((error) => {
          // toast.error(error.message, {
          //   position: toast.POSITION.TOP_RIGHT,
          // });
        });
    }
    setValidated(true);
  };
  const addNewCategory = (e) => {
    setShowParamValidationMsg(false);
    e && e.preventDefault();
    let newfield = {
      resultType: "",
      colorCode: "",
      minScore: "",
      maxScore: "",
    };
    setInputFields([...inputFields, newfield]);
  };
  const removeCategory = (index, e) => {
    e.preventDefault();
    let data = [...inputFields];
    data.splice(index, 1);
    setInputFields(data);
  };
  const handleFormChange = (index, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };
  const addRiskCategoryShow = (e) => {
    e.preventDefault();
    setShowAddRiskCategory(true);
  };
  const RiskColorHelpText = (
    <Tooltip id="Risk_help_test">
      {t("ChooseRepresentRiskCategoryApplicationToolTip.label")}
    </Tooltip>
  );
  const RiskScoreHelpText = (
    <Tooltip id="Risk_help_test">
      {t("RiskScoreLessThanToolTip.label")}
    </Tooltip>
  );
  return (
    <>
      {/* <div className="py-1 text-end">
        <button className="btn btn-primary" onClick={handleShow}>
          {t("AddNewRegulation.label")}
        </button>
      </div> */}

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          < Modal.Title as="h5">
            {editReg ? t("EditCompliance.label") : t("Newcompliance.label")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated}>
            <div className="Single_RC_01">
              <div className="Single_RC_Row01 m-0">
                <div className="p-2">
                  <label className="mb-1">{t("TypeofCompliances.label")} *</label>
                  <input
                    type="text"
                    className="form-control"
                    required
                    disabled={isDisabled}
                    value={regulation}
                    onChange={(e) => setRegulation(e.target.value)}
                  />
                </div>
                <div className="p-2">
                  <label className="mb-1">{t("ReportingFrequency.label")} *</label>
                  <select
                    className="form-select"
                    disabled={isDisabled}
                    required
                    onChange={(e) => setFrequency(e.target.value)}
                    defaultValue={frequency}
                  >
                    <option value="" disabled hidden>
                      {t("Select.label")}
                    </option>
                    {options?.map((items) => (
                      <option value={items.value} key={items.value}>
                        {items.label}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="p-2">
                  <button
                    className="btn btn-secondary"
                    onClick={addRiskCategoryShow}
                  >
                    <BiPlus className="me-1"> </BiPlus>{" "}
                    {t("RiskCategory.label")}
                  </button>
                </div> */}
                {/* {(showAddRiskCategory &&  */}
                <div className="p-2">
                  <div className="card p-0 Risk_category-addRSW_01 ">
                    <Table responsive="sm">
                      <thead>
                        <tr>
                          <th>{t("RiskCategory.label")}</th>
                          <th>
                            {t("Color.label")}
                            <OverlayTrigger placement="bottom" overlay={RiskColorHelpText}>
                              <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                            </OverlayTrigger>
                          </th>
                          <th className="text-center">
                            {t("RiskScore.label")}
                            <OverlayTrigger placement="bottom" overlay={RiskScoreHelpText}>
                              <span className="ms-2  text-dark"><BsQuestionCircle /></span>
                            </OverlayTrigger>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {inputFields?.map((input, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={input.resultType}
                                  required
                                  name="resultType"
                                  onChange={(event) =>
                                    handleFormChange(index, event)
                                  }
                                />
                              </td>
                              <td style={{ width: "20%" }}>
                                <select
                                  className="form-select"
                                  defaultValue={input.colorCode}
                                  required
                                  onChange={(event) =>
                                    handleFormChange(index, event)
                                  }
                                  name="colorCode"
                                >
                                  <option value="" disabled hidden>
                                    {t("Select.label")}
                                  </option>
                                  {RISKPARAMCOLORS.map(({ value, label }) => (
                                    <option key={value} value={value}>
                                      {label}
                                    </option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <ul className="RiskScore_tb_inner">
                                  <li>
                                    {" "}
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="From"
                                      value={input.minScore}
                                      name="minScore"
                                      required
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                    />
                                  </li>
                                  <li> - </li>
                                  <li>
                                    {" "}
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="To"
                                      value={input.maxScore}
                                      name="maxScore"
                                      required
                                      onChange={(event) =>
                                        handleFormChange(index, event)
                                      }
                                    />
                                  </li>
                                </ul>
                              </td>
                              <td>
                                <button
                                  className="btn btn-blank_outline"
                                  onClick={(e) => removeCategory(index, e)}
                                >
                                  <BiTrash />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="p-2">
                      <button
                        className="btn btn-secondary"
                        onClick={addNewCategory}
                      >
                        <BiPlus className="me-1"> </BiPlus> {t("New.label")}
                      </button>
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Cancel.label")}
          </Button>
          {isEdit ? (
            <Button variant="primary" onClick={handleEditRegulation} className="sbmBtn">
              {t("Update.label")}
            </Button>
          ) : (
            <Button variant="primary" onClick={handleCreateRegulation} className="sbmBtn">
              {t("Create.label")}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};
RegulationCreate.propTypes = {
  handleCreateReg: PropTypes.func.isRequired,
};
export default withTranslation()(RegulationCreate);
